import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';

@customElement('webs-grid-column')
export class GridColumn extends LitElement {

  static styles = [css`
    :host {
      --webs-gutter-width-default: var(--gutter-width-default);
      --webs-gutter-width-extra-small: var(--gutter-width-extra-small);
      --webs-gutter-width-small: var(--gutter-width-small);
      --webs-gutter-width-medium: var(--gutter-width-medium);
      --webs-gutter-width-large: var(--gutter-width-large);
      --webs-gutter-width-extra-large: var(--gutter-width-extra-large);
    }

    :host {
      flex: 0 0 auto;
      padding-right: calc(var(--webs-gutter-width-default) / 2 ); padding-left: calc(var(--webs-gutter-width-default) / 2 );
    }

    :host([size]) { flex-grow: 1; flex-basis: 0; max-width: 100%; }
    :host([size="1"]) { flex-basis: 8.333%; max-width: 8.333%; }
    :host([size="2"]) { flex-basis: 16.667%; max-width: 16.667%; }
    :host([size="3"]) { flex-basis: 25%; max-width: 25%; }
    :host([size="4"]) { flex-basis: 33.333%; max-width: 33.333%; }
    :host([size="5"]) { flex-basis: 41.667%; max-width: 41.667%; }
    :host([size="6"]) { flex-basis: 50%; max-width: 50%; }
    :host([size="7"]) { flex-basis: 58.333%; max-width: 58.333%; }
    :host([size="8"]) { flex-basis: 66.667%; max-width: 66.667%; }
    :host([size="9"]) { flex-basis: 75%; max-width: 75%; }
    :host([size="10"]) { flex-basis: 83.333%; max-width: 83.333%; }
    :host([size="11"]) { flex-basis: 91.667%; max-width: 91.667%; }
    :host, :host([size="12"]) { flex-basis: 100%; max-width: 100%; }

    :host([size-offset="1"]) { margin-left: 8.333%; }
    :host([size-offset="2"]) { margin-left: 16.667%; }
    :host([size-offset="3"]) { margin-left: 25%; }
    :host([size-offset="4"]) { margin-left: 33.333%; }
    :host([size-offset="5"]) { margin-left: 41.667%; }
    :host([size-offset="6"]) { margin-left: 50%; }
    :host([size-offset="7"]) { margin-left: 58.333%; }
    :host([size-offset="8"]) { margin-left: 66.667%; }
    :host([size-offset="9"]) { margin-left: 75%; }
    :host([size-offset="10"]) { margin-left: 83.333%; }
    :host([size-offset="11"]) { margin-left: 91.667%; }

    /* -- Extra small -- */
    @media only screen and (min-width: 576px){
      :host { padding-right: calc(var(--webs-gutter-width-extra-small) / 2 ); padding-left: calc(var(--webs-gutter-width-extra-small) / 2 ); }

      :host([xs]), :host([xs="1"]), :host([xs="2"]), :host([xs="3"]), :host([xs="4"]), :host([xs="5"]), :host([xs="6"]), :host([xs="7"]), :host([xs="8"]), :host([xs="9"]), :host([xs="10"]), :host([xs="11"]), :host([xs="12"]) { flex: 0 0 auto; }

      :host([xs]) { flex-grow: 1; flex-basis: 0; max-width: 100%; }
      :host([xs="1"]) { flex-basis: 8.333%; max-width: 8.333%; }
      :host([xs="2"]) { flex-basis: 16.667%; max-width: 16.667%; }
      :host([xs="3"]) { flex-basis: 25%; max-width: 25%; }
      :host([xs="4"]) { flex-basis: 33.333%; max-width: 33.333%; }
      :host([xs="5"]) { flex-basis: 41.667%; max-width: 41.667%; }
      :host([xs="6"]) { flex-basis: 50%; max-width: 50%; }
      :host([xs="7"]) { flex-basis: 58.333%; max-width: 58.333%; }
      :host([xs="8"]) { flex-basis: 66.667%; max-width: 66.667%; }
      :host([xs="9"]) { flex-basis: 75%; max-width: 75%; }
      :host([xs="10"]) { flex-basis: 83.333%; max-width: 83.333%; }
      :host([xs="11"]) { flex-basis: 91.667%; max-width: 91.667%; }
      :host([xs="12"]) { flex-basis: 100%; max-width: 100%; }

      :host([xs-offset="1"]) { margin-left: 8.333%; }
      :host([xs-offset="2"]) { margin-left: 16.667%; }
      :host([xs-offset="3"]) { margin-left: 25%; }
      :host([xs-offset="4"]) { margin-left: 33.333%; }
      :host([xs-offset="5"]) { margin-left: 41.667%; }
      :host([xs-offset="6"]) { margin-left: 50%; }
      :host([xs-offset="7"]) { margin-left: 58.333%; }
      :host([xs-offset="8"]) { margin-left: 66.667%; }
      :host([xs-offset="9"]) { margin-left: 75%; }
      :host([xs-offset="10"]) { margin-left: 83.333%; }
      :host([xs-offset="11"]) { margin-left: 91.667%; }
    }

    /* -- Small -- */
    @media only screen and (min-width: 768px){
      :host { padding-right: calc(var(--webs-gutter-width-small) / 2 ); padding-left: calc(var(--webs-gutter-width-small) / 2 ); }

      :host([sm]), :host([sm="1"]), :host([sm="2"]), :host([sm="3"]), :host([sm="4"]), :host([sm="5"]), :host([sm="6"]), :host([sm="7"]), :host([sm="8"]), :host([sm="9"]), :host([sm="10"]), :host([sm="11"]), :host([sm="12"]) { flex: 0 0 auto; }

      :host([sm]) { flex-grow: 1; flex-basis: 0; max-width: 100%; }
      :host([sm="1"]) { flex-basis: 8.333%; max-width: 8.333%; }
      :host([sm="2"]) { flex-basis: 16.667%; max-width: 16.667%; }
      :host([sm="3"]) { flex-basis: 25%; max-width: 25%; }
      :host([sm="4"]) { flex-basis: 33.333%; max-width: 33.333%; }
      :host([sm="5"]) { flex-basis: 41.667%; max-width: 41.667%; }
      :host([sm="6"]) { flex-basis: 50%; max-width: 50%; }
      :host([sm="7"]) { flex-basis: 58.333%; max-width: 58.333%; }
      :host([sm="8"]) { flex-basis: 66.667%; max-width: 66.667%; }
      :host([sm="9"]) { flex-basis: 75%; max-width: 75%; }
      :host([sm="10"]) { flex-basis: 83.333%; max-width: 83.333%; }
      :host([sm="11"]) { flex-basis: 91.667%; max-width: 91.667%; }
      :host([sm="12"]) { flex-basis: 100%; max-width: 100%; }

      :host([sm-offset="1"]) { margin-left: 8.333%; }
      :host([sm-offset="2"]) { margin-left: 16.667%; }
      :host([sm-offset="3"]) { margin-left: 25%; }
      :host([sm-offset="4"]) { margin-left: 33.333%; }
      :host([sm-offset="5"]) { margin-left: 41.667%; }
      :host([sm-offset="6"]) { margin-left: 50%; }
      :host([sm-offset="7"]) { margin-left: 58.333%; }
      :host([sm-offset="8"]) { margin-left: 66.667%; }
      :host([sm-offset="9"]) { margin-left: 75%; }
      :host([sm-offset="10"]) { margin-left: 83.333%; }
      :host([sm-offset="11"]) { margin-left: 91.667%; }
    }

    /* -- Medium -- */
    @media only screen and (min-width: 992px){
      :host { padding-right: calc(var(--webs-gutter-width-medium) / 2 ); padding-left: calc(var(--webs-gutter-width-medium) / 2 ); }

      :host([md]), :host([md="1"]), :host([md="2"]), :host([md="3"]), :host([md="4"]), :host([md="5"]), :host([md="6"]), :host([md="7"]), :host([md="8"]), :host([md="9"]), :host([md="10"]), :host([md="11"]), :host([md="12"]) { flex: 0 0 auto; }

      :host([md]) { flex-grow: 1; flex-basis: 0; max-width: 100%; }
      :host([md="1"]) { flex-basis: 8.333%; max-width: 8.333%; }
      :host([md="2"]) { flex-basis: 16.667%; max-width: 16.667%; }
      :host([md="3"]) { flex-basis: 25%; max-width: 25%; }
      :host([md="4"]) { flex-basis: 33.333%; max-width: 33.333%; }
      :host([md="5"]) { flex-basis: 41.667%; max-width: 41.667%; }
      :host([md="6"]) { flex-basis: 50%; max-width: 50%; }
      :host([md="7"]) { flex-basis: 58.333%; max-width: 58.333%; }
      :host([md="8"]) { flex-basis: 66.667%; max-width: 66.667%; }
      :host([md="9"]) { flex-basis: 75%; max-width: 75%; }
      :host([md="10"]) { flex-basis: 83.333%; max-width: 83.333%; }
      :host([md="11"]) { flex-basis: 91.667%; max-width: 91.667%; }
      :host([md="12"]) { flex-basis: 100%; max-width: 100%; }

      :host([md-offset="1"]) { margin-left: 8.333%; }
      :host([md-offset="2"]) { margin-left: 16.667%; }
      :host([md-offset="3"]) { margin-left: 25%; }
      :host([md-offset="4"]) { margin-left: 33.333%; }
      :host([md-offset="5"]) { margin-left: 41.667%; }
      :host([md-offset="6"]) { margin-left: 50%; }
      :host([md-offset="7"]) { margin-left: 58.333%; }
      :host([md-offset="8"]) { margin-left: 66.667%; }
      :host([md-offset="9"]) { margin-left: 75%; }
      :host([md-offset="10"]) { margin-left: 83.333%; }
      :host([md-offset="11"]) { margin-left: 91.667%; }
    }

    /* -- Large -- */
    @media only screen and (min-width: 1175px){
      :host { padding-right: calc(var(--webs-gutter-width-large) / 2 ); padding-left: calc(var(--webs-gutter-width-large) / 2 ); }

      :host([lg]), :host([lg="1"]), :host([lg="2"]), :host([lg="3"]), :host([lg="4"]), :host([lg="5"]), :host([lg="6"]), :host([lg="7"]), :host([lg="8"]), :host([lg="9"]), :host([lg="10"]), :host([lg="11"]), :host([lg="12"]) { flex: 0 0 auto; }

      :host([lg]) { flex-grow: 1; flex-basis: 0; max-width: 100%; }
      :host([lg="1"]) { flex-basis: 8.333%; max-width: 8.333%; }
      :host([lg="2"]) { flex-basis: 16.667%; max-width: 16.667%; }
      :host([lg="3"]) { flex-basis: 25%; max-width: 25%; }
      :host([lg="4"]) { flex-basis: 33.333%; max-width: 33.333%; }
      :host([lg="5"]) { flex-basis: 41.667%; max-width: 41.667%; }
      :host([lg="6"]) { flex-basis: 50%; max-width: 50%; }
      :host([lg="7"]) { flex-basis: 58.333%; max-width: 58.333%; }
      :host([lg="8"]) { flex-basis: 66.667%; max-width: 66.667%; }
      :host([lg="9"]) { flex-basis: 75%; max-width: 75%; }
      :host([lg="10"]) { flex-basis: 83.333%; max-width: 83.333%; }
      :host([lg="11"]) { flex-basis: 91.667%; max-width: 91.667%; }
      :host([lg="12"]) { flex-basis: 100%; max-width: 100%; }

      :host([lg-offset="1"]) { margin-left: 8.333%; }
      :host([lg-offset="2"]) { margin-left: 16.667%; }
      :host([lg-offset="3"]) { margin-left: 25%; }
      :host([lg-offset="4"]) { margin-left: 33.333%; }
      :host([lg-offset="5"]) { margin-left: 41.667%; }
      :host([lg-offset="6"]) { margin-left: 50%; }
      :host([lg-offset="7"]) { margin-left: 58.333%; }
      :host([lg-offset="8"]) { margin-left: 66.667%; }
      :host([lg-offset="9"]) { margin-left: 75%; }
      :host([lg-offset="10"]) { margin-left: 83.333%; }
      :host([lg-offset="11"]) { margin-left: 91.667%; }
    }

    /* -- Extra large -- */
    @media only screen and (min-width: 1440px){
      :host { padding-right: calc(var(--webs-gutter-width-extra-large) / 2 ); padding-left: calc(var(--webs-gutter-width-extra-large) / 2 ); }

      :host([xl]), :host([xl="1"]), :host([xl="2"]), :host([xl="3"]), :host([xl="4"]), :host([xl="5"]), :host([xl="6"]), :host([xl="7"]), :host([xl="8"]), :host([xl="9"]), :host([xl="10"]), :host([xl="11"]), :host([xl="12"]) { flex: 0 0 auto; }

      :host([xl]) { flex-grow: 1; flex-basis: 0; max-width: 100%; }
      :host([xl="1"]) { flex-basis: 8.333%; max-width: 8.333%; }
      :host([xl="2"]) { flex-basis: 16.667%; max-width: 16.667%; }
      :host([xl="3"]) { flex-basis: 25%; max-width: 25%; }
      :host([xl="4"]) { flex-basis: 33.333%; max-width: 33.333%; }
      :host([xl="5"]) { flex-basis: 41.667%; max-width: 41.667%; }
      :host([xl="6"]) { flex-basis: 50%; max-width: 50%; }
      :host([xl="7"]) { flex-basis: 58.333%; max-width: 58.333%; }
      :host([xl="8"]) { flex-basis: 66.667%; max-width: 66.667%; }
      :host([xl="9"]) { flex-basis: 75%; max-width: 75%; }
      :host([xl="10"]) { flex-basis: 83.333%; max-width: 83.333%; }
      :host([xl="11"]) { flex-basis: 91.667%; max-width: 91.667%; }
      :host([xl="12"]) { flex-basis: 100%; max-width: 100%; }

      :host([xl-offset="1"]) { margin-left: 8.333%; }
      :host([xl-offset="2"]) { margin-left: 16.667%; }
      :host([xl-offset="3"]) { margin-left: 25%; }
      :host([xl-offset="4"]) { margin-left: 33.333%; }
      :host([xl-offset="5"]) { margin-left: 41.667%; }
      :host([xl-offset="6"]) { margin-left: 50%; }
      :host([xl-offset="7"]) { margin-left: 58.333%; }
      :host([xl-offset="8"]) { margin-left: 66.667%; }
      :host([xl-offset="9"]) { margin-left: 75%; }
      :host([xl-offset="10"]) { margin-left: 83.333%; }
      :host([xl-offset="11"]) { margin-left: 91.667%; }
    }
  `];

  @property({attribute: 'size'})
  sizeMobile = '12';
  @property({attribute: 'xs'})
  sizeXtraSmall: string;
  @property({attribute: 'sm'})
  sizeSmall: string;
  @property({attribute: 'md'})
  sizeMedium: string;
  @property({attribute: 'lg'})
  sizeLarge: string;
  @property({attribute: 'xl'})
  sizeXtraLarge: string;

  @property({attribute: 'size-offset'})
  sizeMobileOffset: string;
  @property({attribute: 'xs-offset'})
  sizeXtraSmallOffset: string;
  @property({attribute: 'sm-offset'})
  sizeSmallOffset: string;
  @property({attribute: 'md-offset'})
  sizeMediumOffset: string;
  @property({attribute: 'lg-offset'})
  sizeLargeOffset: string;
  @property({attribute: 'xl-offset'})
  sizeXtraLargeOffset: string;

  protected render(): unknown {
    return html`
      <slot></slot>
    `;
  }
}
